export default __webpack_public_path__ + "static/media/homeBg.ae20e377.png";